import React from "react";
import { Link } from "react-router-dom";
import { CATEGORIES } from "../utils/dummyData";

const PopularPosts = ({ posts }) => {
  const Card = ({ post }) => {
    let catColor = ['#20B486', '#21E484', '#58c9da', '#423ff3cc','#ff6161', '#ffdd61' ];
    CATEGORIES.map((cat) => {
      let random = Math.floor(Math.random() * catColor.length)
      let color = catColor[random]
      if (cat.label === post?.cat) {
        catColor = color
      }
      return null;
    });

    return (
      <div className="flex gap-2 items-center">
        <img
          src={post?.img}
          alt={post?.user?.name}
          className="w-12 h-12 rounded-full object-cover"
        />
        <div className="w-full flex flex-col gap-1">
          <span
            className={`bg-[${catColor}] w-fit rounded-full px-2 py-0.5 text-dr_gray text-[12px] 2xl:text-sm`}
          >
            {post?.cat}
          </span>
          <Link
            to={`/${post?.slug}/${post?._id}`}
            className="text-black dark:text-white"
          >
            {post?.title}
          </Link>
          <div className="flex gap-2 text-sm">
            <span className="font-medium">{post?.user?.name}</span>
            <span className="text-gray-500">
              {new Date(post?.createdAt).toDateString()}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full flex flex-col gap-8">
      <p className="text-base font-medium -mb-3 text-dr_gray">
        Popular Articles
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-16 justify-between w-full">
        {posts?.map((post, id) => (
          <Card post={post} key={id} />
        ))}
      </div>
    </div>
  );
};

export default PopularPosts;
